export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.accountConfig': '设置',
  'menu.accountConfig.info': '账户设置',
  'menu.accountConfig.enterprise': '企业认证',
  'menu.accountConfig.linked-accounts': '关联账号管理',
  'menu.accountConfig.tokenManagement': 'Token管理',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.knowledge': '话术与知识库',
  'menu.knowledge.keywords': '关键词模板',
  'menu.knowledge.keywords.create': '新建关键词模板',
  'menu.knowledge.keywords.edit': '编辑关键词模板',
  'menu.knowledge.qa': '问答模板',
  'menu.knowledge.qa.create': '新建问答模板',
  'menu.knowledge.qa.edit': '编辑问答模板',
  'menu.knowledge.comprehensive': '综合知识库',
  'menu.advancedTools': '高级运营工具',
  'menu.contentWorkstation': '内容孵化器',
  'menu.contentWorkstation.knowledge': '知识库',
  'menu.contentWorkstation.material': '素材采集',
  'menu.contentWorkstation.creation': '文案创作',
  'menu.contentWorkstation.aiCopywriting': '文案创作',
  'menu.contentWorkstation.imageGeneration': '图片创作',
  'menu.contentWorkstation.videoProduction': '视频制作',
  'menu.contentWorkstation.referenceCopy': '图文爆款复刻',
  'menu.contentWorkstation.draftsLibrary': '稿件箱',
  'menu.contentWorkstation.trendingCollection': '素材采集',
  'menu.contentWorkstation.settings': '创作设置',
  'menu.workbench': '工作台',
  'menu.aiEmployee': 'AI员工',
  'menu.aiEmployee.create': '创建AI员工',
  'menu.aiEmployee.worker-config': '编辑AI员工配置',
  'menu.aiEmployee.saved-configs': '已保存配置',
  'menu.customerService': '客服管理',
  'menu.customerService.messageAggregation': '消息聚合',
  'menu.customerService.history': '历史消息',
  'menu.messageAggregation': '消息聚合',
  'menu.console': '产品中心',
  'menu.customizationWorkstation': '企业定制',
  'menu.modelMarketplace': '模型广场',
  'menu.contentWorkstation.batchCollect': '批量采集对标',
  'menu.contentWorkstation.singleCollect': '单挑采集对标',
  'menu.contentWorkstation.internalHot': '内部爆款录入',
  'menu.contentWorkstation.companyBackground': '企业背景',
  'menu.contentWorkstation.accountPersona': '账号人设',
  'menu.contentWorkstation.seoKeywords': 'SEO关键词',
};
